import { TMChangeOrderBoardAPI } from '@business/api/tm_change_order_board';
import { TimeMaterialBoardResponse } from '@business/entities/tm/TimeMaterialBoardResponse';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class TMChangeOrderBoardBloc extends BaseBloc {
  private readonly boardRepo = new Repository<TimeMaterialBoardResponse>({
    getItemId: board => board.id,
    pagenated: true,
  });

  readonly boards$ = this.boardRepo.items$;

  readonly selectTimeMaterialBoard = this.boardRepo.selectItem;

  onReset() {
    this.boardRepo.reset();
  }

  fetchTimeMaterialBoards = (permission = true) => {
    return TMChangeOrderBoardAPI.fetchTimeMaterialBoards(permission).pipe(
      this.boardRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_board_error') }),
    );
  };

  createTimeMaterialBoard = (data: Partial<TimeMaterialBoardResponse>) => {
    return TMChangeOrderBoardAPI.createTimeMaterialBoard(data).pipe(
      this.boardRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_change_order'),
      }),
    );
  };

  updateTimeMaterialBoard = (id: string, data: Partial<TimeMaterialBoardResponse>) => {
    return TMChangeOrderBoardAPI.updateTimeMaterialBoard(id, data).pipe(
      this.boardRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_change_order'),
      }),
    );
  };

  deleteTimeMaterialBoard = (id: string) => {
    return showDeleteConfirmation('Delete TimeMaterialBoard', 'Do you really want to remove this board?').pipe(
      switchMap(() => TMChangeOrderBoardAPI.deleteTimeMaterialBoard(id)),
      this.boardRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_change_order'),
      }),
    );
  };
}
